<script setup lang="ts">
// import cover from "@/assets/image/regularInsurance/insurance-cover.png";
import { useReferencesStore } from "@/store/references";
import testimonial_1 from "@/assets/image/legalTestimonials/legal-testimonial-6-1.jpg";

const currentId = ref(1);
const refStore = useReferencesStore();

function nextPost(type: string) {
	if (type == "r") {
		if (sectionOneReferences.length - 1 <= currentId.value) {
			currentId.value = 0;
		} else {
			currentId.value += 1;
		}
	} else if (type == "l") {
		if (currentId.value == 0) {
			currentId.value = sectionOneReferences.length - 1;
		} else {
			currentId.value -= 1;
		}
	}
}

function truncateText(text: string) {
	const lines = text.split("\n\n");
	return lines.length > 2 ? lines.slice(0, 2).join("\n") : text;
}

const sectionOneReferences = refStore.testimonialsListLegal.filter(
	(ref) => ref.section === 1,
);
</script>

<template>
	<div class="insurance-wrapper">
		<div class="content-wrapper">
			<div class="title">{{ $t("app.legalTestimonials.title1") }}</div>
			<pre
				class="content"
				v-html="truncateText(sectionOneReferences[currentId].description)"
			></pre>
			<div class="button-wrapper">
				<router-link
					class="home-page-white-button"
					:to="{ name: 'LegalTestimonials' }"
					aria-label="Find out more"
					>{{ $t("app.learnMore") }}</router-link
				>
			</div>
		</div>
		<div
			class="cover-wrapper"
			:style="{
				'background-image':
					'url(' +
					(currentId === 0
						? testimonial_1
						: refStore.testimonialsListLegal[currentId].video) +
					')',
			}"
		>
			<div class="buttons-wrapper">
				<div class="left" @click="nextPost('l')">
					<img
						class="icon"
						src="@/assets/image/icons/arrow-left.svg"
						alt="Previous"
						loading="lazy"
					/>
				</div>
				<div class="right" @click="nextPost('r')">
					<img
						class="icon"
						src="@/assets/image/icons/arrow-right.svg"
						alt="Next"
						loading="lazy"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss">
.insurance-wrapper {
	.testimonial-bold {
		font-weight: 600;
	}
	.testimonial-underline {
		text-decoration: underline;
	}

	&.dark {
		.testimonial-bold {
			color: $text-color-lighter;
		}
		.testimonial-underline {
			color: $text-color-lighter;
		}
	}
}
</style>

<style lang="scss" scoped>
.insurance-wrapper {
	.content-wrapper {
		padding: 24px;

		.button-wrapper {
			display: flex;
			justify-content: center;
		}

		.title {
			font-family: Pelinka, sans-serif;
			font-size: 18px;
			line-height: 24px;
			font-weight: 700;
			margin: 0 0 24px;
			text-transform: uppercase;
			text-align: center;
		}

		.content {
			font-family: "Galano Grotesque Alt", sans-serif;
			font-size: 16px;
			font-weight: 300;
			line-height: 22px;
			margin-bottom: 24px;
			white-space: pre-wrap;
			word-wrap: break-word;

			.subheading {
				margin-bottom: 24px;
			}
			ul {
				margin-left: 24px;

				li {
					margin-bottom: 12px;
				}
			}
		}
	}
	.cover-wrapper {
		aspect-ratio: 100 / 70;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;

		.buttons-wrapper {
			position: absolute;
			top: 24px;
			left: 50%;
			transform: translate(-50%, -50%);
			display: flex;
			z-index: 2;

			.left,
			.right {
				margin-top: 24px;
				width: 35px;
				height: 35px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				.icon {
					width: 20%;
				}
			}

			.left {
				border: 1px solid rgba(0, 0, 0, 0);

				&:hover {
					border: 1px solid $app-dark-color;
					background-color: $app-accent-color1;
				}
			}

			.right {
				background-color: $app-accent-color1;
				border: 1px solid $app-accent-color1;

				&:hover {
					border: 1px solid $app-dark-color;
				}
			}
		}

		&::before {
			@include overlay-mixin;

			background-color: $overlay-home;
		}
	}
}

@media screen and (width >= 760px) {
	.insurance-wrapper {
		.content-wrapper {
			.title {
				font-size: 30px;
				line-height: 38px;
				margin-bottom: 50px;
				margin-top: 26px;
			}

			.content {
				font-size: 18px;
				line-height: 26px;
			}

			.button-wrapper {
				margin-bottom: 26px;
			}
		}

		.cover-wrapper {
			.buttons-wrapper {
				top: 50px;
				.left,
				.right {
					width: 50px;
					height: 50px;
				}
			}
		}
	}
}

@media screen and (width >= 1024px) {
	.insurance-wrapper {
		.content-wrapper {
			padding: 85px;

			.title {
				margin-top: 0;
			}

			.content {
				margin-bottom: 50px;
			}

			.button-wrapper {
				margin-bottom: 0;
			}
		}

		.cover-wrapper {
			.buttons-wrapper {
				top: 85px;
				.left,
				.right {
					width: 70px;
					height: 70px;
				}
			}
		}
	}
}

@media screen and (width >= 1224px) {
	.insurance-wrapper {
		.content-wrapper {
			padding: 85px;
			.title {
				font-size: 40px;
				line-height: 46px;
				margin-bottom: 85px;
			}

			.content {
				font-size: 22px;
				line-height: 30px;
				.subheading {
					font-size: 30px;
					font-weight: 300;
					line-height: 25px;
					margin-bottom: 85px;
				}
				ul {
					li {
						font-size: 22px;
						line-height: 25px;
						margin-bottom: 50px;
					}
				}
			}
		}
	}
	.cover-wrapper {
		position: relative;
		display: none;
	}
}

@media screen and (width >= 1224px) {
	.insurance-wrapper {
		padding: 0;
		display: flex;

		.content-wrapper {
			width: 43%;
			display: flex;
			flex-direction: column;
			justify-content: center;

			.button-wrapper {
				display: flex;
				justify-content: left;
			}

			.title {
				margin: 0 0 100px;
				text-align: start;
			}

			.content {
				margin-bottom: 100px;
			}
		}
		.cover-wrapper {
			width: 57%;
			display: flex;
			align-items: center;

			.buttons-wrapper {
				top: unset;
				bottom: 24px;
				.left,
				.right {
					margin-top: 0;
					width: 70px;
					height: 70px;
				}
			}
		}
	}
}
</style>
